import { Box, Stack } from "@mui/material";
import { CheckGreen } from "src/assets";
import Text from "src/components/Displays/Text";
import { useTranslation } from "react-i18next";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

const ConnectingSuccess = () => {
  const { t } = useTranslation();

  const [getSessionStorageItem] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );

  const handleSubmit = () => {
    const sessionData = getSessionStorageItem();
    if (sessionData) {
      window.location.href = sessionData?.callbackUrlSuccess;
    }
  };

  return (
    <>
      <Stack gap={5}>
        <Stack direction={"column"} gap={5}>
          <Stack alignItems={"start"}>
            <CheckGreen />
          </Stack>
          <Text
            text={t("page.wallboxConnectingSuccess.pageTitle")}
            sx={(theme) => ({
              fontWeight: 500,
              fontSize: "32px",
              lineHeight: "40px",
              fontFamily: "officina",
              color: "#317D5B",
            })}
          />
        </Stack>

        <Text
          text={t("page.wallboxConnectingSuccess.pageSubTitle1")}
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Text
          text={t("page.wallboxConnectingSuccess.pageSubTitle2")}
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Box>
          <PrimaryButton
            onClick={handleSubmit}
            text={t("page.wallboxConnectingSuccess.nextButton")}
          />
        </Box>
      </Stack>
    </>
  );
};

export default ConnectingSuccess;
